// src/store/slices/weeksSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../config/api";
import { Pagination } from "react-bootstrap";

export const fetchweeks = createAsyncThunk(
  "weeks/fetchweeks",
  async (_, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/trainee/weeks/current`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
console.log(response.data.data);

      return response.data.data.weeks;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchAdminweeks = createAsyncThunk(
  "weeks/fetchAdminweeks",
  async (_, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/restaurant/admin/weeks`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
console.log(response.data.data);

      return response.data.data.weeks;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const fetchweek = createAsyncThunk(
  "weeks/fetchweek",
  async (resturantID, thunkAPI) => {
    
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state



      const response = await axios.get(
        `${API_URL}/week/admin/weeks/${resturantID}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );
console.log(response.data.data);

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);

export const createWeek = createAsyncThunk(
  "weeks/createWeek",
  async (weekData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.get(`${API_URL}/restaurant/admin/weeks/resolve?date=${weekData}`, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const updateweek = createAsyncThunk(
  "weeks/updateweek",
  async (weekData, thunkAPI) => {
    console.log(weekData,"weekData");
    
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.put(`${API_URL}/week/admin/weeks/${weekData?.id}`, {name:weekData?.name}, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);export const deleteweek = createAsyncThunk(
  "weeks/deleteweek",
  async (weekID, thunkAPI) => {
    console.log(weekID,"weekData");
    
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.delete(`${API_URL}/week/admin/weeks/${weekID}`, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const weeksSlice = createSlice({
  name: "weeks",
  initialState: {
    list: [],
      singleweek: null,
Pagination:null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchweeks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchweeks.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchweeks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })       .addCase(fetchAdminweeks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminweeks.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchAdminweeks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) 
      
      
            
      
      
      .addCase(fetchweek.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchweek.fulfilled, (state, action) => {
        state.loading = false;
        state.singleweek = action.payload;
      })
      .addCase(fetchweek.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      
      .addCase(createWeek.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createWeek.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createWeek.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(updateweek.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateweek.fulfilled, (state, action) => {
        state.loading = false;
        state.list.push(action.payload);
      })
      .addCase(updateweek.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(deleteweek.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteweek.fulfilled, (state, action) => {
        state.loading = false;
        // state.list.push(action.payload);
      })
      .addCase(deleteweek.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export default weeksSlice.reducer;
